import { Event } from '../../../../standard/v1';

export interface RiteaidEvent extends Event {
    TestProp1: number
}